// extracted by mini-css-extract-plugin
module.exports = {"list":"badges_list__ALEL_","item":"badges_item__DMHEd"};